import { apiDaInscricao } from './axios';

export const obterDemandasEspecificas = async () => {
  const { data: demandasEspecificas } = await apiDaInscricao().get('/demandaEspecifica/obterTodas');
  return demandasEspecificas;  
};